"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _requireAuthentication = _interopRequireDefault(require("../../../require-authentication"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _selectCode = _interopRequireDefault(require("../../../core/select-code"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _linkButton = _interopRequireDefault(require("../../../core/link-button"));
var _nonRankedPaddlerModal = _interopRequireDefault(require("./non-ranked-paddler-modal"));
var _races = _interopRequireDefault(require("./races"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Ranking Class");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Ranking Division");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Paddler");
class EnterRaces extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      classRef: null,
      classDivisionID: null,
      cseBibID: null,
      entryErrorMessage: null
    });
    // For each user we store bib details for the latest entry
    // so if state is not set then we look for defaults
    _defineProperty(this, "_getClassRef", () => {
      if (this.state.classRef !== null) return this.state.classRef;
      if (this.props.userDefaultBib) return this.props.userDefaultBib.classRef;
      return null;
    });
    _defineProperty(this, "_getClassDivisionID", () => {
      if (this.state.classDivisionID !== null) return this.state.classDivisionID;
      if (this.state.classRef) {
        const classDivisions = this.props.classDivisions.filter(cd => cd.classRef === this.state.classRef);
        return classDivisions.length === 1 ? classDivisions[0].id : null;
      }
      if (!this.props.userDefaultBib) return null;
      return this.props.userDefaultBib.classDivisionID;
    });
    _defineProperty(this, "_getClassDivision", () => {
      const classDivisionID = this._getClassDivisionID();
      if (!classDivisionID) return null;
      const classDivisions = this.props.classDivisions.filter(cd => cd.id === classDivisionID && !cd.isExpired);
      return classDivisions.length && classDivisions[0];
    });
    _defineProperty(this, "_getBibID", () => {
      if (this.state.cseBibID !== null) return this.state.cseBibID;
      if (!this.props.userDefaultBib) return null;
      if (this._getClassDivisionID() !== this.props.userDefaultBib.classDivisionID) return null;
      return this.props.userDefaultBib.id;
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        [field]: value
      });
    });
  }
  render() {
    const CHECKOUT_URL = `/checkout`;
    const checkoutButton = /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: 38
      }
    }, !this.props.loaded || !this.props.userEntriesAwaitingPayment ? null : /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      "data-test-id": "checkout-button",
      to: CHECKOUT_URL,
      block: true
    }, "Go to checkout ( ", this.props.userEntriesAwaitingPayment, " entries awaiting payment)"));
    return /*#__PURE__*/_react.default.createElement("div", null, !this.state.entryErrorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._setValue.bind(this, 'entryErrorMessage', null)
      }, "OK"),
      onClose: this.props.onEntryErrorDismissed
    }, this.state.entryErrorMessage), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-class",
      lookup: "RefCodes",
      codeType: "class",
      value: this._getClassRef(),
      onChange: this._setValue.bind(this, 'classRef'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-class-division",
      lookup: "ClassDivisions",
      classRef: this._getClassRef(),
      value: this._getClassDivisionID(),
      onChange: this._setValue.bind(this, 'classDivisionID'),
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      "data-test-id": "select-bib-number",
      lookup: "BibNumbers",
      classDivisionID: this._getClassDivisionID(),
      yearID: +this.props.yearID,
      value: this._getBibID(),
      onChange: this._setValue.bind(this, 'cseBibID'),
      clearable: false
    }), !this._getClassDivision() ? null : this._getClassDivision().isRanking ? null : /*#__PURE__*/_react.default.createElement(_nonRankedPaddlerModal.default, {
      classDivision: this._getClassDivision(),
      yearID: +this.props.yearID,
      setBibID: this._setValue.bind(this, 'cseBibID')
    }))))), !this._getBibID() || !this._getClassDivision() ? null : /*#__PURE__*/_react.default.createElement(_races.default, {
      checkoutButton: checkoutButton,
      setEntryError: this._setValue.bind(this, 'entryErrorMessage'),
      isMultiCompetitionEntry: this.props.isMultiCompetitionEntry,
      competitionSlug: this.props.competitionSlug,
      yearID: +this.props.yearID,
      classDivision: this._getClassDivision(),
      classDivisionID: this._getClassDivisionID(),
      cseBibID: this._getBibID()
    }), checkoutButton);
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  id: true,
  classRef: true,
  classDivisionID: true
};
var _ref5 = {
  id: true,
  isRanking: true,
  genderRef: true,
  genderDescription: true,
  classRef: true,
  classDescription: true,
  rankingDivisionRef: true
};
var _default = exports.default = (0, _requireAuthentication.default)((0, _reactBicycle.connect)(EnterRaces, props => ({
  userEntriesAwaitingPayment: true,
  ["userDefaultBib(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref4,
  classDivisions: _ref5
})
// undefined,
// {renderLoading: true},
));